import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精彩视频
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              编辑精选的高质量海角视频，每一部都值得细细品味
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaItems.map((item) => (
              <article
                key={item.id}
                className="group rounded-2xl bg-background-50 border border-background-200/60 overflow-hidden cursor-pointer hover:border-primary-200 transition-all"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-900/70 text-white text-xs font-medium">
                    {item.duration}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                      <i className="ri-play-fill text-2xl ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <span className="inline-block text-xs font-medium px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 mb-2">
                    {item.tag}
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i>{item.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>{item.views}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}